import axios from './axios';
import qs from 'qs';
import {API_DEFAULT_CONFIG} from '@/config';
// 引入系统API MAP
import {API_CONFIG} from '@/global/module-config';
import {assert} from '@/utils';
import {assign, isEmpty} from 'lodash';

class MakeApi {
  constructor(options) {
    this.api = {};
    this.apiBuilder(options);
  }

  apiBuilder({
    sep = '|',
    debug = false,
    config = {}
  }) {
    Object.keys(config).map(namespace => {
      this._apiSingleBuilder({
        namespace,
        sep,
        debug,
        config: config[namespace]
      });
    });
  }

  _apiSingleBuilder({
    namespace,
    sep,
    debug,
    config
  }) {
    config.forEach(api => {
      const {name, params, method, path} = api;
      const apiName = `${namespace}${sep}${name}`;
      const apiUrl = path;

      debug && assert(name, `${apiUrl}: 接口name属性不能为空`);
      debug && assert(apiUrl.indexOf('/') === 0, `${apiUrl}: 接口路径path，首字符应为/`);

      Object.defineProperty(this.api, apiName, {
        value(outerParams, outerOptions) {
          let _params;
          if (Array.isArray(outerParams)) {
            _params = outerParams;
          } else {
            _params = isEmpty(outerParams) ? params : assign({}, params, outerParams);
          }
          const url = _replaceURLparams(apiUrl, _params);
          return axios(_normoalize(assign({
            url,
            method
          }, outerOptions), _params)).catch(error => { // 全局捕获异常，后续继续then，如果去掉本段代码，则后续不继续then
            // 如果是业务400业务异常，继续抛出异常，以便后续业务逻辑处理
            switch (error.response.status) {
              case 400:
              case 405:
              case 500:
                throw error;
              default:
                break;
            }
          });
        }
      });
    });
  }
}

function _replaceURLparams(url, data) {
  return url.replace(/:([\w\d]+)/ig, (reg, key) => {
    return data[key];
  });
}

function _normoalize(options, data) {
  const method = options.method.toUpperCase();
  if (['POST', 'PUT', 'PATCH'].indexOf(method) > -1) {
    options.data = data;
  } else if (['POST_FORM'].indexOf(method) > -1) { // fanqz add 拓展post form表单提交的方式
    options.data = qs.stringify(data);
    options.method = 'POST';
  } else {
    options.params = data;
  }

  return options;
}

export default new MakeApi({
  config: API_CONFIG,
  ...API_DEFAULT_CONFIG
}).api;
